import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { FilterCriteriaForm } from '@/components/table/schemas/filterCriteriaSchema.ts';
import { buildPageRequestParams } from '@/components/table/types/TableUtil.ts';
import { InvitationListDto } from '@/features/dashboard/invitations/types/InvitationListDto.ts';
import { InvitationDto } from '@/features/dashboard/invitations/types/InvitationDto.ts';
import { CreateInvitationDto } from '@/features/dashboard/invitations/types/CreateInvitationDto.ts';

const invitationsApi = {
  getTableDefinition: async (): Promise<TableDefinitionDto> => {
    return await fetchPrivateApi<TableDefinitionDto>(
      'GET',
      'invitations/table-definition',
    );
  },
  getAll: async (
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaForm,
  ): Promise<PagedDto<InvitationListDto>> => {
    const params = buildPageRequestParams(pageRequest);
    return await fetchPrivateApi<PagedDto<InvitationListDto>>(
      'POST',
      `invitations/all?${params.toString()}`,
      filterCriteria,
    );
  },
  create: async (data: CreateInvitationDto): Promise<InvitationDto> => {
    return await fetchPrivateApi<InvitationDto>('POST', 'invitations', data);
  },
  cancel: async (id: string): Promise<void> => {
    return await fetchPrivateApi<void>('DELETE', `invitations/${id}`);
  },
  resend: async (id: string): Promise<void> => {
    return await fetchPrivateApi<void>('POST', `invitations/${id}/resend`);
  },
};

export default invitationsApi;
